import React from "react";
import { Helmet } from "react-helmet";
import { Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import HeaderThree from "../component/header/HeaderThree";
import LegalDocument from "../component/common/LegalDocument";

// Page shell shared by the legal documents (terms of use, terms & conditions).
const LegalDocumentPage = ({ id, labelKey, contentKey, path }) => {
  const { t } = useTranslation();
  const icon = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive.webp`;
  const title = t(labelKey);

  window.onload = function () {
    document.querySelector(".header--fixed").classList.add("sticky");
  };

  return (
    <div className="active-dark bg_color--ugs">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content="EcoShift ⁕ the digital platform for your eco-positive consumption!" />
        <meta name="keywords" content="ecoshift,shift,impact,transition,eco,friendly,consumption,eco-positive,sustainability,biodiversity,ecoresponsible" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content="EcoShift ⁕ the digital platform for your eco-positive consumption!" />
        <meta property="og:image" content={icon} />
        <meta property="og:url" content={process.env.PUBLIC_URL + "/"} />
        <meta name="twitter:card" content={icon} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://ecoshift.eco${path}`} />
      </Helmet>

      <HeaderThree homeLink="/" logo="symbol-dark" color="color-black" alwaysSticky="true" />

      <Card id={id} className="card_color--ugs ">
        <CardBody>
          <div className="slider-wrapper">
            <div className="fix top-inset-main">
              <div className="service-area creative-service-wrapper pb--80 card_color--ugs ">
                <div className="container">
                  <br />
                  <br />
                  <br />
                  <div className="row">
                    <div className="col-lg-12 mb_sm--0">
                      <LegalDocument i18nKey={contentKey} />
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default LegalDocumentPage;
